import script from "./AdminDashbaord.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashbaord.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashbaord.vue?vue&type=style&index=0&id=0a97d7b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a97d7b6"]])

export default __exports__